import { Button } from '@shadcn/components/ui/button';
import { Copy } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@shadcn/components/ui/tooltip';
import { toast } from 'react-toastify';

export function CopyableTruncatedCell({ value, empty = '—', mono = true, multiline = false }) {
  const str = value != null && value !== '' ? String(value) : '';
  const hasValue = str.length > 0;

  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(str);
      toast.success('Copied to clipboard');
    } catch {
      toast.error('Failed to copy');
    }
  };

  if (!hasValue) {
    return <span className="text-muted-foreground text-sm">{empty}</span>;
  }

  const showCopy = !/^\*+$/.test(str.trim());
  const textClass = mono ? 'font-mono text-xs' : 'text-sm';
  const breakClass = mono ? 'break-all' : 'break-words';

  return (
    <div className="flex w-full min-w-0 max-w-full flex-wrap items-start gap-1">
      <div className="min-w-0 max-w-full flex-1 basis-0">
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              tabIndex={0}
              className={`block w-full min-w-0 cursor-default whitespace-normal leading-snug outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm ${breakClass} ${textClass}`}
            >
              {str}
            </span>
          </TooltipTrigger>
          <TooltipContent
            side="top"
            align="start"
            className={`max-w-[min(90vw,32rem)] break-words text-xs p-2 ${mono ? 'font-mono break-all' : ''}`}
          >
            <p className="whitespace-pre-wrap m-0">{str}</p>
          </TooltipContent>
        </Tooltip>
      </div>
      {showCopy && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={`h-7 w-7 shrink-0 flex-none text-muted-foreground hover:text-foreground ${multiline ? 'self-start' : ''}`}
          onClick={handleCopy}
          title="Copy"
          aria-label="Copy to clipboard"
        >
          <Copy className="h-3.5 w-3.5" />
        </Button>
      )}
    </div>
  );
}
